import { Inject, Injectable } from '@angular/core';
import { ACCOUNTING_GROUP_REPOSITORY, AccountingGroupsRepository } from '@core/repositories/accounting-groups.repository';
import { AccountingGroup } from '@shared/interfaces/accounting-group';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountingGroupsService {
  constructor(
    @Inject(ACCOUNTING_GROUP_REPOSITORY) protected repository: AccountingGroupsRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(accountingGroup: AccountingGroup): Observable<any> {
    return this.repository.add(accountingGroup);
  }

  edit(accountingGroup: AccountingGroup): Observable<any> {
    return this.repository.edit(accountingGroup);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
